import './i18n';
import './dayjs';
import './styles/index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {registerSW} from 'virtual:pwa-register';

import App from './App';

const INTERVAL = 30 * 1000;

registerSW({
  immediate: true,
  onRegistered(registration) {
    registration &&
      setInterval(() => {
        console.log('Checking for updates...');

        return registration.update();
      }, INTERVAL);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
